var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "calculator" } },
    [_c("calculator-content")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }